import api from '@utils/api';

export const deleteCompany = async (id) => {
    return new Promise(async (resolve, reject) => {
        try {
            const {data} = await api.put(`/company/${id}`, {is_active: false});
            resolve(data.data);
        } catch (error) {
            reject(error.response.data);
        }
    });
};
export const getCompanies = async () => {
    try {
        const response = await api.get('/companies');        
        return response.data.data;
    } catch (error) {
        throw error.response.data;
    }
};

export const getCompaniesWithTaskFlowModule = async () => {
    try {
        const response = await api.get('/companies');        
        return response.data.data.filter(company =>
            company.modules?.some(module =>
              module.module === "task-flow"
            )
        );
    } catch (error) {
        throw error.response.data;
    }
};

export const getCompaniesWithPurchaseModule = async () => {
    try {
        const response = await api.get('/companies');

        return response.data.data.filter(company =>
            company.modules?.some(module =>
              module.module === "purchase"
            )
        );
    } catch (error) {
        throw error.response.data;
    }
};

export const getCompanyById = async (id) => {
    try {
        const response = await api.get(`/company/${id}`);
        return response.data.data;
    } catch (error) {
        throw error.response.data;
    }
};
export const createCompany = async (companyData) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await api.post("/companies", companyData);
            resolve(response.data);
        } catch (error) {
            reject(error.response.data);
        }
    });
};
export const updateCompany = async (id, companyData) => {
    return new Promise(async (resolve, reject) => {
        try {
            const response = await api.put(`/company/${id}`, companyData)
            resolve(response.data);
        } catch (error) {
            reject(error.response.data);
        }
    });
};

/**
 * @param {int} company
 *
 * @returns {Promise<*>}
 */
export const getEmployees = async (company) => (
  api.get(`company/${company}/employees`)
);

export const getUserCompanies = async () => {
  const response = await api.get('companies/user');
  return response.data.data;
};

export const importCompanies = async () => {
    try {      
        const response = await api.post('/companies/import');
        return response.status === 204;
    } catch (error) {
        throw error.response?.data;
    }
};

export const importWebpostoCompanies = async () => {
    try {
        const response = await api.post('/companies/import-webposto');
        return response.status === 204;
    } catch (error) {
        throw error.response?.data;
    }
};

export const importProtheusCompanies = async () => {
    try {
        const response = await api.post('/companies/import-protheus');
        return response.data;
    } catch (error) {
        throw error.response?.data;
    }
};

export const importAlternativeCodes = async () => {
    try {
        const response = await api.post('/companies/import-alternative-codes');
        return response.data;
    } catch (error) {
        throw error.response?.data;
    }
};

export const toggleCompanyActive = async (id, isActive) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { data } = await api.put(`/company/${id}`, { is_active: isActive });
      resolve(data.data);
    } catch (error) {
      reject(error.response.data);
    }
  });
};